import React, { useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import AppBar from './components/AppBar';
import OrdersPage from './pages/OrdersPage';
import KioskReportsPage from './pages/KioskReportsPage';
import ProtectedRoute from './Auth/ProtectedRoute';
import Login from './Auth/Login';
import LabReportsPage from './pages/LabReportsPage';
import ConsultationsPage from './pages/ConsultationsPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import GenerateReportPage from './pages/GenerateReportPage';
import AppUsersPage from './pages/AppUsersPage';
import SupplementOrdersPage from './pages/SupplementOrdersPage';
import CreateOfflineOrderPage from './pages/CreateOfflineOrderPage';
import FoodLogPage from './pages/FoodLogPage';
import InventoryPage from './pages/InventoryPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import AddProductPage from './pages/AddProductPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { Box, CssBaseline, Toolbar } from '@mui/material';
import CouponSections from './pages/CouponsSection';
import SendNotificationPage from './pages/SendNotificationPage';
import ClinicalScreeningPage from './pages/ClinicalScreeningPage';

function App() {

  const [mobileOpen, setMobileOpen] = useState(false);

  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <ToastContainer />
      <Routes>

        <Route path="/login" element={<Login />} />

        <Route path="/*" element={
          <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Sidebar
              mobileOpen={mobileOpen}
              handleDrawerToggle={handleDrawerToggle}
              expanded={sidebarExpanded}
              setExpanded={setSidebarExpanded}
            />

            <Box component="main" sx={{ flexGrow: 1, px: 0, py: 0, bgcolor: 'background.paper' }}>
              <Routes>
                <Route path="/" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
                <Route path="/consultations" element={<ProtectedRoute><ConsultationsPage /></ProtectedRoute>} />
                <Route path="/subscriptions" element={<ProtectedRoute><SubscriptionsPage /></ProtectedRoute>} />
                <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
                <Route path="/orders/create-offline" element={<ProtectedRoute><CreateOfflineOrderPage /></ProtectedRoute>} />
                <Route path="/kiosk-reports" element={<ProtectedRoute><KioskReportsPage /></ProtectedRoute>} />
                <Route path="/food-log" element={<ProtectedRoute><FoodLogPage /></ProtectedRoute>} />
                <Route path="/inventory" element={<ProtectedRoute><InventoryPage /></ProtectedRoute>} />
                <Route path="/inventory/add" element={<ProtectedRoute><AddProductPage /></ProtectedRoute>} />
                <Route path="/inventory/:productId" element={<ProtectedRoute><ProductDetailsPage /></ProtectedRoute>} />
                <Route path="/lab-reports" element={<ProtectedRoute><LabReportsPage /></ProtectedRoute>} />
                <Route path="/clinical-screening" element={<ProtectedRoute><ClinicalScreeningPage /></ProtectedRoute>} />
                <Route path="/app-users" element={<ProtectedRoute><AppUsersPage /></ProtectedRoute>} />
                <Route path="/supplement-orders" element={<ProtectedRoute><SupplementOrdersPage /></ProtectedRoute>} />
                <Route path='/Coupons-section' element={<ProtectedRoute><CouponSections /></ProtectedRoute>} />
                <Route path="/send-notification" element={<ProtectedRoute><SendNotificationPage /></ProtectedRoute>} />
                <Route path="/generate-report" element={<ProtectedRoute><GenerateReportPage /></ProtectedRoute>} />
                <Route path="*" element={<ProtectedRoute><Navigate to="/" replace /></ProtectedRoute>} />
              </Routes>
            </Box>
          </Box>
        } />
      </Routes>
    </>
  );
}

export default App;
